export default {
  init(selector, config) {
    // JavaScript to be fired on the edit profile page

  },
  finalize() {

    // JavaScript to be fired on the home page, after the init JS

     /* if occupation selected Others then display others box to enter*/
     if($('#occupation').val() == 'other (occupation not listed)'){
      $(".occupation_others_div").removeClass('d-none');
      $(".occupation_main_div").addClass('col-sm-4 mb-4');
      $(".occupation_main_div").removeClass('col-sm-6 mb-6');
      $(".caresettings_main_div").addClass('col-sm-4 mb-4');
      $(".caresettings_main_div").removeClass('col-sm-6 mb-6');
    }

    // Show selected occupation categories
    $('#occupation').on('change', function () { // TODO This stopped working
      const target = $( '#' + $(this).find(':selected').data('target') );
      const animateIn = $(this).find(':selected').data('animation-in');
      const occupation_value = $(this).val(); // get the dropdown value
      //BIZ_823 START: Making occupation_others element null only if profilevalidation
      var profileValidationClick = $(".profileValidation");
      if(!profileValidationClick.data('clicked')) {
        $("#occupation_others").val('');
      }
      //BIZ_823 START: Making occupation_others element null only if profilevalidation

      $(".occupation_others_div").addClass('d-none'); // by default others field hide
      $(".occupation_main_div").removeClass('col-sm-4 mb-4');
      $(".occupation_main_div").addClass('col-sm-6 mb-6');

      $(".caresettings_main_div").removeClass('col-sm-4 mb-4');
      $(".caresettings_main_div").addClass('col-sm-6 mb-6');

      if(occupation_value == 'other (occupation not listed)'){
          $(".occupation_others_div").removeClass('d-none');
          $(".occupation_main_div").addClass('col-sm-4 mb-4');
          $(".occupation_main_div").removeClass('col-sm-6 mb-6');
          $(".caresettings_main_div").addClass('col-sm-4 mb-4');
          $(".caresettings_main_div").removeClass('col-sm-6 mb-6');
      }


      $(`[data-link-group="occupation-categories"]`)
        .addClass('d-none');

      target.show().removeClass('d-none');

      setTimeout(() => {
        target
          .removeClass('d-none')
          .addClass(`animated ${animateIn}`);
      }, 10);
    });

    /* BIZ-768 START - Added the changes for the change email popup */

    $(".changeemail").on("click",  function() {
      $('#changeEmailModal').modal('show');
      $("#erroremail").hide();
      $("#changeEmail").val("");
      $("#changeEmail").parent().parent().removeClass("u-has-error");
      $("#changeEmail-error").hide();
    })

    $("#cancelchangeemail").on("click",  function() {
      $('#changeEmailModal').modal('hide');
      $("#erroremail").hide();
      $("#changeEmail").attr('placeholder', 'email@email.com');
    })
    
    $("#submit_email").on("click" , function() {
      var email = $("#changeEmail").val();
      var action="checkemail";
      var url = ajaxdta.ajaxurl + "?action=email-check";

      if(email != ''){
        $.ajax({
          type: "POST",
          url: url,
          data: {
            email: email, action:action
          },
          dataType:"JSON",
          success: function (data) { 
            var isValid = data.valid;
            if (!isValid){
              $("#erroremail").show().text('Invalid email address')
              $( "#changeEmail-error").hide();
              $("#changeEmail").val("");
              return
            } 
            var mString = data.present;
            if(mString)  {
              $("#erroremail").show().text("Error! This email is already in use for another account");
              $( "#changeEmail-error").hide();
              $("#changeEmail").val("");
            }else{
              $('#changeEmailModal').modal('hide');
              $( "#email_update" ).submit();
            }         
          },
        });
      }else{
        $("#changeEmail").trigger("keyup");
      }

    });

    /* BIZ-768 END - Added the changes for the change email popup */

    $("#changeEmail").on("focus", function(){
      $("#erroremail").hide();
      $("#changeEmail").val("");
      $("#changeEmail").attr('placeholder', 'email@email.com');
    });

    const country = $('#countryselect').val();
    if(country != "Australia"){
      $("#mainpostcodediv").addClass('d-none');
      $("#mainstatediv").addClass('d-none');
      $("#statediv").addClass('d-none');
      $('#state option').each(function() {

        if ( $(this).val() == '' ) {
          $(this).prop('selected', true);
        }else { 
          $(this).prop('selected', false);
        }  
      });

      $('#state').data('rule-required',false);
      $("#postcodediv").addClass('d-none');
      $("#postcode").val('');
      $('#postcode').data('rule-required',false);

    }

    $('#countryselect').on('change', function () {
      const country_value = $(this).val();
      if(country_value != "Australia"){
        $("#mainpostcodediv").addClass('d-none');
        $("#mainstatediv").addClass('d-none');
        $("#statediv").addClass('d-none');
        $('#state option').each(function() {

          if ( $(this).val() == '' ) {
              $(this).prop('selected', true);
          }else { 
              $(this).prop('selected', false);
          }  

        });
        $('#state').data('rule-required',false);
        $("#postcodediv").addClass('d-none');
        $("#postcode").val('');
        $('#postcode').data('rule-required',false);
      }else{
        $("#mainpostcodediv").removeClass('d-none');
        $("#mainstatediv").removeClass('d-none');
        $("#statediv").removeClass('d-none');
        $("#postcodediv").removeClass('d-none');
        $('#state').data('rule-required',true);
        $('#postcode').data('rule-required',true);
      }
    });
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/edit-profile.js